import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './VerificationPending.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

const VerificationPending = () => {
  const location = useLocation();
  const [resendStatus, setResendStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');
  
  // Get email from location state or use empty string
  const email = location.state?.email || '';
  const customMessage = location.state?.message || '';
  
  const handleResendVerification = async () => {
    if (!email || resendStatus === 'loading') return;
    
    setResendStatus('loading');
    setMessage('');
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/users/resend-verification`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Failed to resend verification email');
      }
      
      setResendStatus('success');
      setMessage(data.message || 'Verification email sent! Please check your inbox.');
    } catch (error) {
      setResendStatus('error');
      setMessage(error.message);
    }
  };
  
  return (
    <div className="verification-pending">
      <div className="verification-pending-card">
        <div className="icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#6c5ce7" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        
        <h1>Verification Pending</h1>
        
        <p className="main-message">
          {customMessage || "We've sent a verification link to your email address. Please check your inbox and click the link to activate your account."}
        </p>
        
        {email && (
          <div className="email-box">
            <p className="email-sent-to">Verification email sent to:</p>
            <p className="email-address">{email}</p>
          </div>
        )}
        
        {resendStatus === 'success' && (
          <p className="success-message">{message}</p>
        )}
        
        {resendStatus === 'error' && (
          <p className="error-message">{message}</p>
        )}
        
        <div className="verification-actions">
          <button 
            onClick={handleResendVerification} 
            className={`resend-button ${resendStatus === 'loading' ? 'loading' : ''}`}
            disabled={resendStatus === 'loading' || !email}
          >
            {resendStatus === 'loading' ? 'Sending...' : 'Resend Verification Email'}
          </button>
          
          <Link to="/login" className="login-link">
            Return to Login
          </Link>
        </div>
        
        <div className="help-text">
          <p>
            If you don't see the email in your inbox, please check your spam folder.
            If you continue to have issues, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationPending;